<template>
    <div class="__wrapper" @scroll="onFeedScoll">
        <div class="__head">
            <div class="lia-intro">
                <h1>Find your <span class="site-color">new LIA</span> here</h1>
                <p>Thousands of LIA in the computer, engineering and technology sectors are waiting for you.</p>
            </div>
            <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input type="text" :value="filter_form.text" @keyup="searchInternship" placeholder="Type in to Search…" />
            </div>
        </div>

        <div class="__body" @scroll="onFeedScoll">
            <div class="body-wrapper">
                <div class="filter-widget">
                    <div class="filter-widget-header">
                        <h1>Filters</h1>
                        <widgetButton v-if="$getLoggedUser() &&
                            $getLoggedUser().account_type == 4
                            " @click="addNewPrivateLia()" class="btn-secondary">
                            Add LIA +
                        </widgetButton>
                    </div>
                    <div class="filter-widget-body">

                        <!--  <div v-if="false" class="h-spacer"></div>
<widgetCheckbox v-if="false" title="Created by me" v-model="intern_filter_create_by_me"
  @change="onSearchInternshipCreateByMe"></widgetCheckbox>-->

                        <widgetDropdown style="position: relative;" v-model="show_school_filter" :right="true"
                            :hover="false" :interactive="true">
                            <button class="btn-dropdown" style="width: 100%">
                                Select Schools
                                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                            </button>
                            <div slot="dropdown" class="dropdown-widget" style="padding: 0px;right: 0;">
                                <widgetListSelecter v-model="schools_opt" :showSearch="false"
                                    @close="show_school_filter = false" @confirm="onFilterBySchool">
                                </widgetListSelecter>
                            </div>
                        </widgetDropdown>

                        <div class="v-spacer"></div>


                        <widgetDropdown style="position: relative;" v-model="show_worktype_filter" :right="true"
                            :hover="false" :interactive="true">
                            <button class="btn-dropdown" style="width: 100%">
                                LIA type
                                <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                            </button>
                            <div slot="dropdown" class="dropdown-widget" style="padding: 0px;right: 0;">
                                <widgetListSelecter v-model="worktype_filter" :showSearch="false"
                                    @close="show_worktype_filter = false" @confirm="onSearchInternshipByWorktype">
                                </widgetListSelecter>
                            </div>
                        </widgetDropdown>
                        <div class="v-spacer"></div>

                        <div class="row">
                            <widgetCheckbox title="Interested" v-model="intern_filter_status_input"
                                @change="onSearchInternshipByStatus"></widgetCheckbox>
                            <div class="h-spacer"></div>
                            <widgetCheckbox title="My LIA" v-model="intern_filter_mylia_input"
                                @change="onSearchInternshipCreateByMe"></widgetCheckbox>

                        </div>

                        <div class="v-spacer"></div>

                        <!--
                          <widgetFeedFiltterClass v-if="false" style="width: 50%" placeholder="Search by class"
                            @onSubmit="onSearchInternshipByClass"></widgetFeedFiltterClass> -->

                        <widgetFeedFilterTags placeholder="Search tag" @onSubmit="onSearchInternshipByTag">
                        </widgetFeedFilterTags>






                        <!--
                       
                          <widgetFeedFilterTags placeholder="Search tag" @onSubmit="onSearchInternshipByTag">
                          </widgetFeedFilterTags>
                          <div class="h-spacer"></div>
                          <widgetFeedFilterLocation placeholder="Search location" @onSubmit="onSearchInternshipByLocation">
                          </widgetFeedFilterLocation>
                        -->

                    </div>


                    <div class="filter-reset" v-if="isFilteringIntern">
                        <button class="btn btn-clear-filter" @click="clearAllFilters()">
                            Clear Filters
                        </button>
                    </div>

                </div>
                <div class="lia-container">
                    <!-- Start of LIA -->
                    <div v-if="!showMainLoading && internship_data && internship_data.data.length > 0"
                        class="assignments-items">
                        <masonry :cols="{ default: 2, 600: 1, }" :gutter="{ default: '30px', 700: '15px' }">
                            <internshipItem v-for="( item, index ) in  internship_data.data " :item="item" :key="index"
                                type="school" :class="{ active: false }" @select="selectInternship"
                                @apply="applyInternship">
                            </internshipItem>
                            <div class="internship-loading-widget">
                                <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="showLoading"
                                    :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader">
                                </loading>
                            </div>
                        </masonry>


                    </div>
                    <div v-else-if="!showMainLoading" class="not-found" style="padding: 50px 0px">
                        <widgetNotFoundWidget title="No LIA found">
                            <img class="widget-img" src="@/assets/icons/member-notfound.svg" />
                        </widgetNotFoundWidget>
                    </div>

                    <div v-if="showMainLoading" class="main-internship-loading-widget">
                        <loading :height="25" color="#1ba5a4" :opacity="1" :width="25" :active.sync="showMainLoading"
                            :is-full-page="false" :can-cancel="false" background-color="transparent" class="loader">
                        </loading>
                    </div>

                    <!-- End of of LIA -->
                </div>
            </div>
        </div>

        <!-- Chat section -->
        <div class="floater">
            <chat></chat>
        </div>
        <!-- Chat section -->

        <!-- Share modal -->
        <share-helper v-if="show_share_modal" @onClose="show_share_modal = false" :url="share_info.url"
            :title="share_info.title" :description="share_info.description" />
        <addPrivateInternshipModal v-if="show_add_private_lia_modal" @close="show_add_private_lia_modal = false"
            @success="show_add_private_lia_modal = false"></addPrivateInternshipModal>

        <!--  Add private lia dialog  -->
        <widgetModal v-if="show_add_private_lia_dialog_modal" :title="'Create LIA'" :subtitle="''" btnlefttext="Create LIA"
            btncentertext="Cancel" :leftloading="false" :rightloading="false" :centerloading="false" :footerhidden="false"
            footer_padding="10px 18px 30px 30px" header_padding="30px 0px 20px 31px" body_padding="0px 30px" width="550px"
            :hiderightbtn="true" @onLeftClick="createPrivateLia()"
            @onCenterClick="show_add_private_lia_dialog_modal = false">
            <div class="widget-modal-body-noscoll">
                <p>
                    When you create your private LIA you cannot choose another LIA and
                    your teacher will be informed of your choice.
                </p>
                <widgetCheckbox v-model="dont_show_again_private_lia_dialog" title="Don’t show this again"></widgetCheckbox>
            </div>
        </widgetModal>

        <!-- Lia Wizard -->
        <widgetWizard v-if="showLiaWizard" :slides="liaWizardSlides" @close="onCloseLiaWizard"></widgetWizard>


    </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import Chat from "../components/Chat/Chat";
import { eventBus } from "../main";
import dropdownMenu from "../components/Partials/dropdownMenu";
import widgetFeedFilterTags from "@/components/widgets/widgetFeedFilterTags.vue";
import widgetFeedFiltterClass from "@/components/widgets/widgetFeedFiltterClass.vue";
import internshipItem from "@/views/feed/component/internship_item.vue";
import addPrivateInternshipModal from "@/views/feed/component/add_private_internship_modal.vue";

export default {
    name: "Feeds",
    components: {
        Chat,
        dropdownMenu,
        widgetFeedFilterTags,
        internshipItem,
        widgetFeedFiltterClass,
        addPrivateInternshipModal,
    },
    data() {
        return {
            schools_opt: [],
            liaWizardSlides: [
                {
                    title: 'Access LIAs',
                    content: 'On this LIA page, you have access to all the LIAs shared by your school, allowing you to explore and express your interests',
                },
                {
                    title: 'Filter LIAs',
                    content: 'In order to make your searching easier, you  should use the tags for your school and class given to you by your school.',
                },
                {
                    title: 'Add your own LIA',
                    content: 'You can also create and add your own LIA, and your instructor will be automatically notified.',
                }
            ],
            showLiaWizard: false,
            show_lia_filters: false,
            show_add_private_lia_dialog_modal: false,
            dont_show_again_private_lia_dialog: false,
            show_add_private_lia_modal: false,
            show_share_modal: false,
            share_info: {
                url: "",
                title: "Hello there",
                description: "This is a description",
            },
            internship_data: null,
            showLoading: false,
            sticky: false,
            chatCollapsed: false,
            chatList: [],
            chatItems: [],
            feedsData: { data: [] },
            chats: [],
            searchchat: "",
            comment: { text: "" },
            tab_type: "ass",
            intern_filter_worktype: "",
            intern_filter_status_input: false,
            intern_filter_create_by_me: false,
            intern_filter_worktype_onsite_input: false,
            intern_filter_worktype_remote_input: false,
            intern_filter_worktype_hybrid_input: false,
            intern_filter_worktype_flexible_input: false,
            intern_filter_mylia_input: false,
            filter_form: {
                showMine: false,
                text: "",
                status: "",
                worktype: [],
                id: null,
                tags: [],
                location: "",
                schools: [],
                classes: null,
                url_type: "",
                next_page_url: "",
            },
            worktype_filter: [
                { name: "Flexible", value: "flexible" },
                { name: "Hybrid", value: "hybrid" },
                { name: "On Site", value: "onsite" },
                { name: "Remote", value: "remote" },
            ],
            show_worktype_filter: false,
            showFeedLoading: false,
            show_school_filter: false,
            showMainLoading: false,
        };
    },
    computed: {
        ...mapGetters([
            "getMeProfile",
            "getSearchResults",
            "getFeedsPosts",
            "getLoader",
        ]),
        isFilteringIntern() {
            let vm = this;
            return (
                vm.filter_form.worktype.length > 0 ||
                vm.filter_form.classes != null ||
                vm.filter_form.id != null ||
                vm.filter_form.tags.length > 0 ||
                vm.filter_form.location > 0 ||
                vm.filter_form.status == "applied" ||
                vm.filter_form.text.length > 0 ||
                vm.filter_form.schools.length > 0 ||
                vm.filter_form.showMine == true
            );
        },
        me() {
            return this.getMeProfile.user;
        },
        userId() {
            return this.getMeProfile.user.id;
        },
        isCustomer() {
            return this.getMeProfile.user.account_type == 2;
        },
        isName() {
            return this.getMeProfile.user.first_name;
        },
        user() {
            let job = "";
            let country = "";
            let city = "";

            if (this.getMeProfile.employment.length > 0)
                job = this.getMeProfile.employment[0].company.name;
            if (this.getMeProfile.profile.location) {
                if (this.getMeProfile.profile.location.country_id)
                    country = this.getMeProfile.profile.location.country.name;
                if (this.getMeProfile.profile.location.city_id)
                    city = this.getMeProfile.profile.location.city.name;
            }
            return {
                profile: this.getMeProfile.user.profile_picture,
                names:
                    this.getMeProfile.user.first_name +
                    " " +
                    this.getMeProfile.user.last_name,
                email: this.getMeProfile.user.email,
                phone: this.getMeProfile.profile.phone,
                available: "Available from",
                available_from: this.getMeProfile.profile.available_from,
                city: city,
                country: country,
                cover_picture: this.getMeProfile.profile.cover_photo,
                location: this.getMeProfile.profile.address,
                job: job,
            };
        },

        feeds() {
            return this.getFeedsPosts;
        },
    },
    watch: {
        searchchat: function (val) {
            this.$store.dispatch("POST_SEARCH_CONNECTION", { query: val });
        },

        showReactions: (val) => {
            if (!val) this.likes = [];
        },
        $route(to, from) {
            this.getFeeds(this.$route.params.tag);
        },
        "feedsData.data": (data) => {
            // if (data.length) {
            // }
            // // this.isFetching = true
            // else {
            // }
        },
    },
    mounted() {
        let vm = this;
        vm.getInternship("init");
        if (vm.$route.query.internship) {
            vm.filter_form.id = vm.$route.query.internship;
            vm.getInternship("init");
        }
        vm.showLiaWizarModal();
        vm.getSchools();
    },
    methods: {
        onFeedScoll({ target }) {
            // Modify header according to feed scoll
            let vm = this;
            if (window.innerWidth > 400) {
                vm.header_height = "0px";
                vm.body_height = "100%";
            } else {
                vm.header_height = "41px";
                vm.body_height = "calc(100% - 41px)";
            }
            // Get new feeds on feeds scoll
            if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
                if (!vm.showLoading && vm.internship_data.current_page < vm.internship_data.last_page) {
                    vm.getInternship("next");
                }
            }
        },
        getSchools() {
            let vm = this;
            vm.$store
                .dispatch("SCHOOL_DROPDOWN_ALL_CLASS")
                .then((response) => {
                    vm.schools_opt = response.data.map((item, index) => {
                        return {
                            name: item.name,
                            value: item.id,
                        };
                    });
                })
                .catch((error) => {
                });
        },
        showLiaWizarModal() {
            let vm = this;
            if (!vm.$localStorage.get("dont_show_again_lia_feed_wizard")) {
                vm.$localStorage.set("dont_show_again_lia_feed_wizard", true);
                vm.showLiaWizard = true;
            }
        },
        onCloseLiaWizard() {
            let vm = this;
            vm.$localStorage.set("dont_show_again_lia_feed_wizard", true);
            vm.showLiaWizard = false;
        },
        createPrivateLia() {
            let vm = this;
            if (vm.dont_show_again_private_lia_dialog) {
                vm.$localStorage.set("dont_show_again_private_lia_dialog", true);
            }
            vm.show_add_private_lia_dialog_modal = false;
            vm.show_add_private_lia_modal = true;
        },
        addNewPrivateLia() {
            let vm = this;
            if (vm.$localStorage.get("dont_show_again_private_lia_dialog")) {
                vm.show_add_private_lia_dialog_modal = false;
                vm.show_add_private_lia_modal = true;
            } else {
                vm.show_add_private_lia_dialog_modal = true;
            }
        },
        clearAllFilters() {
            let vm = this;
            vm.intern_filter_worktype = "";
            vm.intern_filter_status_input = false;
            vm.intern_filter_create_by_me = false;
            vm.filter_form = {
                showMine: false,
                text: "",
                status: "",
                worktype: [],
                tags: [],
                id: null,
                location: "",
                schools: [],
                classes: null,
                url_type: "",
                next_page_url: "",
            };
            eventBus.$emit("reset_filter");
            vm.getInternship();
        },
        onFilterBySchool(schools) {
            let vm = this;
            vm.show_school_filter = false;
            vm.filter_form.schools = schools;
            vm.getInternship();
        },
        onSearchInternshipByClass(data) {
            let vm = this;
            vm.filter_form.classes = data;
            vm.getInternship();
        },
        onSearchInternshipByWorktype(data) {
            let vm = this;
            vm.filter_form.worktype = [];
            vm.show_worktype_filter = false;
            data.forEach((type) => {
                if (type == "onsite") {
                    [type, "On site", "on site", "On Site", "Onsite", "onsite"].forEach(
                        (it) => {
                            vm.filter_form.worktype.push(it);
                        }
                    );
                } else if (type == "remote") {
                    [type, "Remote"].forEach((it) => {
                        vm.filter_form.worktype.push(it);
                    });
                } else if (type == "hybrid") {
                    [type, "Hybrid"].forEach((it) => {
                        vm.filter_form.worktype.push(it);
                    });
                } else if (type == "flexible") {
                    [type, "Flexible"].forEach((it) => {
                        vm.filter_form.worktype.push(it);
                    });
                }
            });
            vm.getInternship();
        },
        onSearchInternshipCreateByMe({ target }) {
            let vm = this;
            if (target.checked) {
                vm.filter_form.showMine = true;
            } else {
                vm.filter_form.showMine = false;
            }
            vm.getInternship();
        },
        onSearchInternshipByStatus({ target }) {
            let vm = this;
            if (target.checked) {
                vm.filter_form.status = "applied";
            } else {
                vm.filter_form.status = "";
            }
            vm.getInternship();
        },
        onSearchInternshipByLocation(data) {
            let vm = this;
            vm.filter_form.location = data;
            vm.getInternship();
        },
        onSearchInternshipByTag(data) {
            let vm = this;
            vm.filter_form.tags = data;
            vm.getInternship();
        },
        searchInternship({ target }) {
            let vm = this;
            vm.filter_form.text = target.value;
            vm.getInternship();
        },
        getInternship(type = "init") {
            let vm = this;
            if (type == "init") {
                vm.showMainLoading = true;
            } else {
                vm.showLoading = true;
            }
            vm.filter_form.url_type = type;
            vm.filter_form.next_page_url = vm.internship_data
                ? vm.internship_data.next_page_url
                : "";
            vm.$store
                .dispatch("INSTRUCTOR_GET_ALL_INTERNSHIP", vm.filter_form)
                .then((responce) => {
                    vm.showLoading = false;
                    vm.showMainLoading = false;
                    responce.data.data = responce.data.data.map((item, index) => {
                        eventBus.$set(item, "checked", false);
                        eventBus.$set(item, "loading", false);
                        eventBus.$set(item, "expand_student", false);
                        if (index == 0) {
                            eventBus.$set(item, "expanded", true);
                        } else {
                            eventBus.$set(item, "expanded", false);
                        }
                        return item;
                    });
                    if (type == "init") {
                        if (vm.internship_data) {
                            vm.internship_data.next_page_url = "";
                            vm.internship_data.current_page = "";
                            vm.internship_data.last_page = "";
                        }
                        vm.internship_data = responce.data;
                    } else {
                        vm.internship_data.next_page_url = responce.data.next_page_url;
                        vm.internship_data.current_page = responce.data.current_page;
                        vm.internship_data.last_page = responce.data.last_page;
                        responce.data.data.forEach((item) => {
                            vm.internship_data.data.push(item);
                        });
                    }
                })
                .catch((error) => {
                    vm.showLoading = false;
                    vm.showMainLoading = false;
                });
        },
        validateAccountsType(accounts) {
            if (Array.isArray(accounts)) {
                return true;
            }
            return false;
        },
        notifyUserApplied() {
            let vm = this;
            vm.$notify({
                group: "status",
                title: "Message",
                text: "You already have internship",
                type: "warn",
                duration: 3000,
            });
        },
        selectInternship(item) {
            let vm = this;
            item.loading = true;
            vm.$store
                .dispatch("STUDENT_ACCEPT_INTERNSHIP", {
                    user_id: vm.$getLoggedUser().id,
                    internship_id: item.id,
                    interested: true,
                })
                .then((value) => {
                    item.loading = false;
                    let logged_user = vm.$getLoggedUser();
                    logged_user.has_internship = true;
                    vm.$localStorage.set("logged_user_data", JSON.stringify(logged_user));
                    vm.getInternship();
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Thank you for your feedback",
                        type: "success",
                        duration: 3000,
                    });
                })
                .catch((reason) => {
                    item.loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong, try again",
                        type: "warn",
                        duration: 3000,
                    });
                });
        },
        applyInternship(item) {
            let vm = this;
            vm.$store
                .dispatch("APPLY_INTERNSHIP", {
                    id: item.id,
                    company_id: item.company_id,
                })
                .then((responce) => {
                    vm.getInternship();
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Now you have applied to internship",
                        type: "success",
                        duration: 3000,
                    });
                })
                .catch((error) => {
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong, try again",
                        type: "warn",
                        duration: 3000,
                    });
                });
        },

    },
    updated() {

    },
    created() {

    },
    destroyed() {

    },
};
</script>
  
<style lang="scss" scoped>
.__wrapper {
    background: rgba(239, 239, 239, 0.49);
    position: fixed;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    padding-top: 55px;
    display: flex;
    flex-direction: column;

    @media (min-width: 300px) and (max-width: 630px) {
        bottom: 50px;
        overflow-y: auto;
        display: block;
    }

    .__head {
        height: max-content;
        padding: 20px 10%;
        background: #fff;

        @media (min-width: 300px) and (max-width: 630px) {
            padding: 20px 30px;
        }

        .search-widget {
            border: 1px solid #ddd;
            height: 35px;
            width: 100%;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;
            width: 50%;

            @media (min-width: 300px) and (max-width: 630px) {
                width: 100%;
            }

            img {
                width: 15px;
                height: 15px;
            }

            input {
                height: 42px;
                width: 100%;
                padding-left: 15px;
                outline: none;
                border: none;
                font-family: "Nunito";
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                color: #707070;
            }
        }
    }

    .__body {
        height: calc(100% - 140px);
        overflow-y: auto;
        transition: 200ms ease-in;
        margin-bottom: 5px;
        position: relative;

        @media (min-width: 300px) and (max-width: 630px) {
            height: unset;
            overflow-y: unset;
        }


        .body-wrapper {
            padding: 5px 10%;
            display: grid;
            grid-template-columns: 1fr 4fr;
            grid-gap: 5px;

            @media (min-width: 300px) and (max-width: 630px) {
                grid-template-columns: 1fr;
                padding: 5px 10px;
            }

            .filter-widget {
                display: flex;
                flex-direction: column;
                position: sticky;
                top: 5px;
                align-self: start;
                background-color: #fff;
                border-radius: 5px;
                padding: 10px;
                border: 1px solid #ddd;

                @media (min-width: 300px) and (max-width: 630px) {
                    width: 100%;
                    position: relative;
                    margin-bottom: 10px;
                }

                .filter-widget-header {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 10px;
                }

                .filter-widget-body {
                    .v-spacer {
                        margin-bottom: 10px;
                    }

                    .btn-dropdown {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0px 10px;
                        width: 140px;
                        height: 35px;
                        border: 1px solid #ddd;
                        border-radius: 5px;
                    }
                }
            }

            .lia-container {
                display: flex;
                flex-direction: column;
                position: relative;

                .assignments-items {
                    width: 100%;

                    .internship-loading-widget {
                        position: relative;
                        height: 200px;
                        width: 100%;
                        margin-top: 20px;
                        border-radius: 10px;
                        overflow: hidden;
                    }
                }

                .not-found {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .main-internship-loading-widget {
                    position: relative;
                    height: 400px;
                    width: 100%;
                    border-radius: 5px;
                }


            }
        }
    }
}
</style>